import themeConfig from '../theme.json';

const toNumber = (value, fallback) => {
    if (typeof value === 'number') {
        return value;
    }

    if (typeof value === 'string') {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            return parsed;
        }
    }

    return fallback;
};

const rawBreakpoints = themeConfig?.settings?.custom?.tokens?.breakpoint ?? {};

export const BREAKPOINTS = Object.keys(rawBreakpoints).reduce(
    (acc, key) => ({
        ...acc,
        [key]: toNumber(rawBreakpoints[key], undefined),
    }),
    {}
);

const DEFAULT_BREAKPOINTS = {
    lg: 1024,
    'wp-admin-bar': 782,
};

Object.entries(DEFAULT_BREAKPOINTS).forEach(([key, value]) => {
    if (!BREAKPOINTS[key]) {
        BREAKPOINTS[key] = value;
    }
});

const getMaxBreakpointBoundary = (slug, value) =>
    slug === 'wp-admin-bar' ? value : value - 0.02;

export const getBreakpointValue = (slug, fallback) =>
    BREAKPOINTS[slug] ?? fallback ?? BREAKPOINTS.lg;

export const MEDIA_QUERIES = Object.entries(BREAKPOINTS).reduce(
    (acc, [slug, value]) => ({
        ...acc,
        [slug]: {
            min: `(min-width: ${value}px)`,
            max: `(max-width: ${getMaxBreakpointBoundary(slug, value)}px)`,
        },
    }),
    {}
);

export const getMediaQuery = ({ breakpoint, min = false, max = true }) => {
    const fallbackValue = getBreakpointValue(breakpoint);

    if (!fallbackValue) {
        return null;
    }

    if (min && max) {
        return null;
    }

    if (min) {
        return MEDIA_QUERIES[breakpoint]?.min || `(min-width: ${fallbackValue}px)`;
    }

    const maxBoundary = getMaxBreakpointBoundary(breakpoint, fallbackValue);
    return MEDIA_QUERIES[breakpoint]?.max || `(max-width: ${maxBoundary}px)`;
};

const rawMaxWidths = themeConfig?.settings?.custom?.tokens?.maxWidth ?? {};

export const MAX_WIDTHS = Object.keys(rawMaxWidths).reduce(
    (acc, key) => ({
        ...acc,
        [key]: toNumber(rawMaxWidths[key], undefined),
    }),
    {}
);

export const getMaxWidthValue = (slug, fallback) =>
    MAX_WIDTHS[slug] ?? fallback ?? null;

export const getMaxWidthVar = (slug) =>
    slug ? `var(--sts-max-width-${slug})` : null;

export const sortMaxWidthEntries = (slugs) => {
    const entries = Object.entries(MAX_WIDTHS);
    const filtered = slugs?.length
        ? entries.filter(([key]) => slugs.includes(key))
        : entries;

    return [...filtered].sort((a, b) => {
        const aVal = a[1] ?? 0;
        const bVal = b[1] ?? 0;
        return bVal - aVal;
    });
};
